import React from "react";
import "./Home.css";
import appStoreLogo from "./img/ic_app_store.png";
import playStoreLogo from "./img/ic_play_store.png";

export default class Home extends React.Component {
  render() {
    return (
      <div className="Home-container">
        <div className="Home-content-column">
          <div className="Home-button-row">
            <div
              className="Home-download-button"
              onClick={() =>
                window.open("https://xtaxihk.page.link/passenger", "_blank")
              }
            >
              <p>乘客版下載</p>
            </div>
            <div
              className="Home-download-button"
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.wolitaxi.driver&hl=zh_HK",
                  "_blank"
                )
              }
            >
              <p>司機版(Android)下載</p>
            </div>
          </div>
          <div className="Home-download-description-row">
            <div className="Home-download-description-text">
              iOS 和 Android 同步上架 請即下載
            </div>
            <img
              className="Home-app-store-logo"
              src={appStoreLogo}
              alt={"Error"}
            />
            <img
              className="Home-play-store-logo"
              src={playStoreLogo}
              alt={"Error"}
            />
          </div>
          <div className="Home-copyright">
            @2024 X TAXI. All rights reserved.
          </div>
        </div>
      </div>
    );
  }
}
